import { render } from "./2FA.vue?vue&type=template&id=7776acce&scoped=true"
import script from "./2FA.vue?vue&type=script&lang=js"
export * from "./2FA.vue?vue&type=script&lang=js"

import "./2FA.vue?vue&type=style&index=0&id=7776acce&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7776acce"]])

export default __exports__